import { PageHeader, SectionDivider, HeritageSeal } from "@/components/primitives";
import { BrandLogo } from "@/components/BrandLogo";

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHeader
        kicker="Our Story"
        title="Mangaroa Valley"
        subtitle="A family patch, since 1932"
      />

      <article className="h-card p-6 sm:p-10 shadow-card">
        <div className="flex justify-center mb-6">
          <BrandLogo size={140} />
        </div>

        <p className="font-display text-2xl italic text-ink-soft leading-relaxed text-center">
          "We're not in the business of perfect flowers. We're in the business of memory."
        </p>

        <div className="mt-8">
          <SectionDivider label="The Valley" />
        </div>

        <p className="mt-6 text-ink-soft leading-loose">
          Heritage Dahlias sits halfway up Mangaroa Valley, a quiet fold of farmland north-east of Wellington
          where the nor'wester finds the patch each afternoon, and the morning fog softens everything to sage.
          The first tubers were planted here by my great-grandmother in the spring of 1932, lifted in autumn,
          stored under the house in dry sand, and replanted again the next year. Three generations on, the same
          varieties still come up in May.
        </p>

        <div className="mt-8">
          <SectionDivider label="The Bloom Keeper" />
        </div>

        <p className="mt-6 text-ink-soft leading-loose">
          We made The Bloom Keeper because a gardening notebook is one of the most loved, most lost things in
          a household. Where did that peach dahlia come from? When did the first bloom open last year? Which
          bed had the slug trouble?
        </p>
        <p className="mt-4 text-ink-soft leading-loose">
          The Bloom Keeper is a pocket almanack, a place to record varieties, sketch beds, and watch your own
          season unfold. Warm, hand-written, and unhurried. The way the patch has always been kept.
        </p>

        <div className="mt-10">
          <SectionDivider label="With love" />
        </div>
        <p className="font-display italic text-center text-2xl text-sage-dark mt-6">
          From the Mangaroa patch, to yours.
        </p>
      </article>
    </div>
  );
}
